import { render, staticRenderFns } from "./WheelOfFortune.vue?vue&type=template&id=7ff3f99d&scoped=true"
import script from "./WheelOfFortune.vue?vue&type=script&lang=js"
export * from "./WheelOfFortune.vue?vue&type=script&lang=js"
import style0 from "./WheelOfFortune.vue?vue&type=style&index=0&id=7ff3f99d&prod&lang=scss&scoped=true"
import style1 from "./WheelOfFortune.vue?vue&type=style&index=1&id=7ff3f99d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ff3f99d",
  null
  
)

export default component.exports